export default __webpack_public_path__ + "static/media/Proverp_Home.ae0aa3c0.png";